<template>
  <div
    class="contract-card"
    :class="[
      { danger: isPastDue && !isWithinRenewalPeriod },
      { warning: isWithinRenewalPeriod },
    ]"
  >
    <div class="contract-card__label" v-if="canRenew">
      <span>{{ label }}</span>
    </div>

    <div class="contract-card__header">
      <img :src="iconDeviceURL" alt="Ícone do dispositivo">
      <span>{{ info.type }}</span>
    </div>

    <div class="contract-card__description" :title="info.model">
      <p>{{ info.model }}</p>
    </div>

    <Button label="Veja mais" @click.prevent.stop="isModalActive = true" />

    <transition name="fade">
      <DetailsModal
        key="detailsModal"
        v-if="isModalActive"
        :contract="info"
        @close="isModalActive = false"
        @renew="renew()"
        @change="change()"
      />
    </transition>
  </div>
</template>

<script>
import moment from 'moment'
import Button from '@/components/ui/Button'
import DetailsModal from './DetailsModal'

moment.locale('pt-BR')

export default {
  name: 'ContractCard',
  components: {
    Button,
    DetailsModal
  },
  props: {
    info: { type: Object, required: true }
  },
  data () {
    return {
      isModalActive: false
    }
  },
  computed: {
    iconDeviceURL () {
      const type = this.info.type.toLowerCase()
      const name = type === 'celular' ? 'cellphone' : type
      return require(`@/assets/svg/icon-device-${name}.svg`)
    },
    dueDate () {
      return moment(this.info.expirationDate)
        .format('D [de] MMMM [de] YYYY')
        .toLowerCase()
    },
    isPastDue () {
      return moment() > moment(this.info.expirationDate)
    },
    isWithinRenewalPeriod () {
      const today = moment()
      const dueDate = moment(this.info.expirationDate)
      const diff = parseInt(dueDate.diff(today, 'days'))
      return diff >= 0 && diff <= 15
    },
    canRenew () {
      const today = moment()
      const dueDate = moment(this.info.expirationDate)
      const diff = parseInt(dueDate.diff(today, 'days'))
      return diff <= 15
    },
    label () {
      if (!this.canRenew) {
        return ''
      }

      return this.isWithinRenewalPeriod
        ? 'Próxima do vencimento'
        : 'Apólice vencida'
    }
  },
  methods: {
    renew () {
      this.$emit('openModal', 'renew')
    },
    change () {
      this.$emit('openModal', 'change')
    }
  }
}
</script>

<style lang="scss" scoped>
.contract-card {
  background-color: #ffffff;
  border-color: #c8c8c8;
  border-radius: 8px;
  border-style: solid;
  border-width: 1px;
  margin-top: 25px;
  padding: 32px 24px 24px 24px;
  position: relative;
  width: 100%;

  &.danger {
    border-color: red;

    .contract-card__label {
      span {
        background-color: #df2e24;
      }
    }
  }

  &.warning {
    border-color: orangered;

    .contract-card__label {
      span {
        background-color: #ff7a19;
      }
    }
  }

  &__label {
    left: 0;
    text-align: center;
    top: -12px;
    position: absolute;
    width: 100%;

    span {
      border-radius: 8px;
      color: white;
      font-family: Oscine;
      font-size: 16px;
      padding: 6px 20px;
    }
  }

  &__header {
    align-items: center;
    display: flex;
    justify-content: flex-start;

    img {
      height: 22px;
      margin-right: 12px;
    }

    span {
      color: #707070;
      font-family: Rubik, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
    }
  }

  &__description {
    height: 48px;
    overflow: hidden;
    margin: 8px 0 24px;

    p {
      color: #444444;

      font-family: Oscine, sans-serif;
      font-style: normal;
      font-weight: bold;
      font-size: 18px;
      line-height: 24px;
      display: -webkit-box;
      overflow: hidden;
      text-align: justify;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}
</style>
